import { ArtifactFormProp, UserDocumentFile } from "../types"
import matchHelper from "./match.helper"
import secureHelper from "./secure.helper"
import util from "./util.helper"

export const inputRequiredRule = {
    required: {
        value: true,
        message: "El campo es obligatorio.",
    }
}

export const inputCurpRule = {
    maxLength: {
        value: 18,
        message: "La CURP debe contener 18 caracteres."
    },
    minLength: {
        value: 18,
        message: "La CURP debe contener 18 caracteres."
    },
    pattern: {
        value: matchHelper.regexp.curp,
        message: "La CURP que ingresaste es incorrecta, verifícala e intenta nuevamente.",
    }
}

export const inputAlphanumeric = {
    validate: (value: string) => /^\w+$/.test(value) || "El campo solo debera contener caracteres alfanumericos"
}

export const inputVersion = {
    validate: (value: string) => /^\d+(\.\d+)*$/.test(value) || "Número de versión invalida"
}

export const formArtifactGroupName = 'artifacts'
export const inputsArtifactTypes = new Array(10).fill('').map((_, idx) => `${formArtifactGroupName}.${idx}.type`)

export const initialArtifact: ArtifactFormProp = {
    item: null,
    type: '',
    documentationReference: ''
}

export async function setMultipartImage(userFiles: UserDocumentFile[], onAppend?: (item: UserDocumentFile, file: File) => void, encrypt?: boolean) {
    const formData = new FormData();
    for (let item of userFiles) {
        if (item.img && item.img.length > 0) {
            let verifiedImage = await util.processImageFileSize(item.img[0], 1, { maxWidthOrHeight: 1400 });
            let size = verifiedImage.size;
            let blob = verifiedImage.slice(0, size, "image/jpg");
            let fileName = `${item.code}.jpg`
            if (encrypt) {
                let arrayData = await blob.arrayBuffer()
                blob = secureHelper.encriptFile(arrayData)
            }
            let newFile = new File([blob], fileName, { type: "image/jpg" })
            onAppend?.(item, newFile)
            formData.append("files", newFile);
        }
    }
    return formData
}